import React, { useEffect, useState } from "react";
import { Row, Col } from "components/shared/layout";
import Input from "components/input";
import TextArea from "components/textarea";
import styled from "styled-components";
import Checkbox from "components/checkbox";
import Button from "components/button";
import { connect } from "formik";
import api from "api";
import Select from "components/select";
import mapToSelect from "utils/mapToSelect";
import Tooltip from "components/tooltip";
import Modal, { ModalContent, ModalContext } from "components/modal";
import DropZone from "components/dropzone";
import UploadedFile from "components/uploaded-file";
import colours from "assets/colours";
import { ReactComponent as InfoIcon } from "assets/images/info-icon.svg";

const FinancialDetailsContainer = styled.div`
  width: 100%;
`;

const FieldWrapper = styled(Col)`
  padding: 10px;
`;

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
`;

const FileUploadedMsg = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: ${colours.grey2};
  padding: 10px;
  img {
    margin-right: 0.5em;
  }
`;

const FinancialDetails = ({ formik, editable }) => {
  const [showTaxCertModal, setShowTaxCertModal] = useState(false);
  const [showBBBEECertModal, setShowBBBEECertModal] = useState(false);

  return (
    <FinancialDetailsContainer>
      <Row>
        <FieldWrapper xs={12} md={6}>
          {formik.values.tax_certificate?.fileURL && (
              <ButtonWrapper>
                <UploadedFile
                  fileName={
                    formik.values.tax_certificate?.file?.name || "View tax certificate"
                  }
                  fileURL={formik.values.tax_certificate?.fileURL || ""}
                  onRemove={
                    editable
                      ? () => formik.setFieldValue("tax_certificate", null)
                      : null
                  }
                />
              </ButtonWrapper>
          )}
          {(editable) && !formik.values.tax_certificate?.fileURL && (
              <ButtonWrapper>
                <Button variant='zltoLightBlue' onClick={() => setShowTaxCertModal(true)}>
                  Tax Clearance Certificate
                </Button>
              </ButtonWrapper>
          )}
        </FieldWrapper>
      </Row>


      {showTaxCertModal && (
        <Modal onClose={() => setShowTaxCertModal(false)}>
          <ModalContent>
            <ModalContext.Consumer>
              {({ closeModal }) => (
                <DropZone name="tax_certificate" closeModal={closeModal} />
              )}
            </ModalContext.Consumer>
          </ModalContent>
        </Modal>
      )}
      {showBBBEECertModal && (
        <Modal onClose={() => setShowBBBEECertModal(false)}>
          <ModalContent>
            <ModalContext.Consumer>
              {({ closeModal }) => (
                <DropZone name="BBBEE_certificate" closeModal={closeModal} />
              )}
            </ModalContext.Consumer>
          </ModalContent>
        </Modal>
      )}
    </FinancialDetailsContainer>
  );
};
export default connect(FinancialDetails);
